import { render } from "./ViewAgent.vue?vue&type=template&id=4564dead"
import script from "./ViewAgent.vue?vue&type=script&lang=js"
export * from "./ViewAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__